import Layout from '@/layout';

const giftVoucherRouter = {
  path: '/giftVoucher',
  component: Layout,
  redirect: '/giftVoucher/archive',
  name: 'GiftVoucher',
  alwaysShow: true,
  meta: {
    title: '礼品券',
    icon: 'clipboard',
  },
  children: [
    {
      path: 'archive',
      component: () => import('@/views/giftVoucher/index'),
      name: 'GiftVoucherArchive',
      meta: { title: '礼品券档案', noCache: true },
    },
  ],
};

export default giftVoucherRouter;
